export default "48526b4ed811c6ff.png"